import React, { type ReactNode, useEffect, useRef, useState } from 'react';

import { type HelpTextType } from '@/components/Modals/HelpModal/HelpTextConfig';

import { ModalContext } from './ModalContext';
import { type SellParams } from './ModalContext';

export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [openClaimModal, setOpenClaimModal] = useState<boolean>(false);
  const [openSellModal, setOpenSellModal] = useState<boolean>(false);
  const [openTCoinModal, setOpenTCoinModal] = useState<boolean>(false);
  const [isGoodsBoostModalOpen, setIsGoodsBoostModalOpen] =
    useState<boolean>(false);
  const [isFactoryBoostModalOpen, setIsFactoryBoostModalOpen] =
    useState<boolean>(false);
  const [isQuarryBoostModalOpen, setIsQuarryBoostModalOpen] =
    useState<boolean>(false);
  const [openNewGoodsModal, setOpenNewGoodsModal] = useState<boolean>(false);
  const [earnRewardModal, setEarnRewardModal] = useState<boolean>(false);
  const [helpModal, setHelpModal] = useState<boolean>(false);
  const [helpType, setHelpType] = useState<HelpTextType>('main');
  const [sellModalParams, setSellModalParams] = useState<SellParams | null>(
    null,
  );
  const [idResourse, setIdResourse] = useState<string>('');
  const [tekstClaimModal, setTekstClaimModal] = useState<string>('');
  const [imgNewGoods, setImgNewGoods] = useState<string>('');

  const helpTextModal = (type: HelpTextType): void => {
    setHelpModal(true);
    setHelpType(type);
  };

  const claimModal = (tekst: string): void => {
    setOpenClaimModal(true);
    setTekstClaimModal(tekst);
  };

  const sellModal = (data: SellParams): void => {
    setOpenSellModal(true);
    setSellModalParams(data);
  };

  const newGoods = (img: string): void => {
    setOpenNewGoodsModal(true);
    setImgNewGoods(img);
  };

  useEffect(() => {
    if (!openClaimModal) return;

    const timer = setTimeout(() => setOpenClaimModal(false), 4000);

    return (): void => clearTimeout(timer);
  }, [openClaimModal]);

  const buildResourceRef = useRef<HTMLDivElement>(null);

  const scrollToBuildResource = (): void => {
    buildResourceRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <ModalContext.Provider
      value={{
        helpType,
        setHelpType,
        helpTextModal,
        helpModal,
        setHelpModal,
        earnRewardModal,
        setEarnRewardModal,
        isGoodsBoostModalOpen,
        setIsGoodsBoostModalOpen,
        isFactoryBoostModalOpen,
        setIsFactoryBoostModalOpen,
        isQuarryBoostModalOpen,
        setIsQuarryBoostModalOpen,
        openNewGoodsModal,
        setOpenNewGoodsModal,
        imgNewGoods,
        newGoods,
        openTCoinModal,
        setOpenTCoinModal,
        openClaimModal,
        setOpenClaimModal,
        idResourse,
        setIdResourse,
        tekstClaimModal,
        setTekstClaimModal,
        claimModal,
        buildResourceRef,
        scrollToBuildResource,
        openSellModal,
        setOpenSellModal,
        sellModal,
        sellModalParams,
        setSellModalParams,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
